import React from 'react'
import { ExplanationType } from '../../../../lib/translation-explanations'

type Props = {
   explanationType: ExplanationType
   explanation: string | undefined
}

const InlineExplanation = (props: Props) => {
   if (props.explanationType === ExplanationType.Context) {
      return (
         <i className="inline ml-[10px] text-[17px] italic first-letter:lowercase">
            ({props.explanation})
         </i>
      )
   }

   return null
}

export default InlineExplanation
